var tag = document.createElement('script');
tag.id = 'iframe-demo';
tag.src = 'https://www.youtube.com/iframe_api';
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var player;
var videoButton = document.getElementById('video-button');
var videoContainer = document.getElementById("lp-video");
var headerContainer = document.querySelector(".lp__header");
var headerVideo = document.getElementById("header-video");

function onYouTubeIframeAPIReady() {
  player = new YT.Player('youtube-video', {
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onStateChange
    }
  });
}

function onPlayerReady(event) {
  createButtonListener();
}

function onStateChange(event) {
  if (event.data == YT.PlayerState.PLAYING) {
    headerContainer.classList.add('dim');
    headerVideo.pause();
  }

  if (event.data != YT.PlayerState.PLAYING) {
    headerContainer.classList.remove('dim');
    headerVideo.play();
  }
}

function createButtonListener() {
  videoButton.addEventListener('click', function() {
    event.preventDefault();
    const yOffset = -60;
    const y = videoContainer.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
    player.playVideo();
  });
}